import { render } from "./EnPersonIntroAllView.vue?vue&type=template&id=36cdfba1&scoped=true"
import script from "./EnPersonIntroAllView.vue?vue&type=script&lang=js"
export * from "./EnPersonIntroAllView.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/en/personintro-all.css?vue&type=style&index=1&id=36cdfba1&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36cdfba1"]])

export default __exports__